/**
 * View component for /questions/:questionId
 *
 * Displays a single question from the 'byId' map in the question reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as questionActions from '../questionActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import question components
import QuestionLayout from '../components/QuestionLayout.js.jsx';

// import question css modules
import questionStyles from '../questionModuleStyles.css';


class SingleQuestion extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(questionActions.fetchSingleIfNeeded(match.params.questionId));
  }

  render() {
    const { questionStore } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual question object from the map
     */
    const selectedQuestion = questionStore.selected.getItem();

    const isEmpty = (
      !selectedQuestion
      || !selectedQuestion._id
      || questionStore.selected.didInvalidate
    );

    return (
      <QuestionLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h3> Single Question </h3>
              {isEmpty ?
                (questionStore.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: questionStore.isFetching ? 0.5 : 1 }}>
                  <h1> { selectedQuestion.name }
                    <Link className="yt-btn small u-pullRight" to={`${this.props.match.url}/update`}> UPDATE Question </Link>
                  </h1>
                  <hr/>
                  <p> <em>Other characteristics about the Question would go here.</em></p>
                </div>
              }
            </div>
          </section>
        </div>
      </QuestionLayout>
    )
  }
}

SingleQuestion.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    questionStore: store.question
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleQuestion)
);



// WEBPACK FOOTER //
// modules/question/views/SingleQuestion.js.jsx